import { render, staticRenderFns } from "./portfolio_index.vue?vue&type=template&id=21b494e6&scoped=true&"
import script from "./portfolio_index.vue?vue&type=script&lang=js&"
export * from "./portfolio_index.vue?vue&type=script&lang=js&"
import style0 from "./portfolio_index.vue?vue&type=style&index=0&id=21b494e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b494e6",
  null
  
)

export default component.exports